import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import React, { useEffect, useState } from 'react';
import DashboardLoading from '../VisaoGeralLoading';
import { boxStyles, periodoStyles } from './styles';

const getCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    .format(value)
    .replace('R$', '')
    .trim();

const SelectPeriodo = ({ periodoFixo, opcoesFiltro, periodo, setPeriodo }) => {
  const classes = periodoStyles();

  const exibeCampoPeriodo = () => {
    if (periodo) {
      return (
        <FormControl variant="outlined" className={classes.formControlSelect}>
          <Select
            id="periodo"
            name="periodo"
            value={periodo}
            onChange={(e) => {
              setPeriodo(e.target.value);
            }}
            className={`${classes.select}`}
            MenuProps={{
              MenuListProps: {
                disablePadding: true,
              },
            }}
          >
            {opcoesFiltro?.map((opcao) => (
              <MenuItem key={opcao.valor} className={`${classes.options}`} value={opcao.valor}>
                {opcao.descricao}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }
    return null;
  };

  return periodoFixo ? (
    <Typography className={`${classes.periodoFixo}`}>{periodoFixo}</Typography>
  ) : (
    exibeCampoPeriodo()
  );
};

const Content = ({ valor, descricao, detalhes, classes, visualizarDados }) => {
  return (
    <>
      <Grid item xs={11}>
        {visualizarDados ? (
          <Typography className={`${classes.title}`} variant="h4">
            {getCurrency(valor || 0)}
          </Typography>
        ) : (
          <Typography className={`${classes.visualizarDados}`} variant="h4">
            <span>****</span>
          </Typography>
        )}

        <Typography className={`${classes.subtitle}`}>{descricao}</Typography>
      </Grid>

      <Grid item xs={1} container alignItems="flex-end" justify="flex-end">
        {detalhes && visualizarDados && (
          <Tooltip title={detalhes} placement="right" classes={{ tooltip: classes.tooltip }}>
            <div>
              <InfoIcon fontSize="small" />
            </div>
          </Tooltip>
        )}
      </Grid>
    </>
  );
};

const Dashboard = ({
  titulo,
  valor,
  descricao,
  periodoFixo,
  detalhes,
  opcoesFiltro = [],
  periodo,
  className,
  setPeriodo = () => {},
  buscarDadosDashboard = async () => {},
  visualizarDados = true,
}) => {
  const [loading, setLoading] = useState(false);
  const classes = boxStyles();

  useEffect(() => {
    const buscar = async () => {
      setLoading(true);

      await buscarDadosDashboard(periodo);

      setLoading(false);
    };

    buscar();
    // Memoização intencional: as funções são recriadas a cada render e incluí-las anularia o memo;
    // o estado que elas leem já está nas dependências.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodo]);

  return (
    <Card className={className}>
      <CardHeader
        title={
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography>{titulo}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} container justify="flex-end">
              <SelectPeriodo
                periodoFixo={periodoFixo}
                opcoesFiltro={opcoesFiltro}
                periodo={periodo}
                setPeriodo={setPeriodo}
              />
            </Grid>
          </Grid>
        }
        classes={{ title: classes.header }}
      />

      <hr className={classes.hr} />

      <CardContent className={`${classes.content}`}>
        <Grid container className={`${classes.contentGrid}`}>
          {loading ? (
            <DashboardLoading />
          ) : (
            <Content
              valor={valor}
              descricao={descricao}
              detalhes={detalhes}
              classes={classes}
              visualizarDados={visualizarDados}
            />
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Dashboard;
